import React, { useState, useLayoutEffect } from 'react';

import styles from '../../../../utils/styles';
import { TypographyElements } from '../../../foundation';
import IconClock from '../../icons/icon-clock';

import './Timer.scss';

export interface ITimer {
  elapsed?: string;
  expandable?: boolean;
  expanded?: boolean;
}

const Timer: React.FC<ITimer> = ({ elapsed, expandable = false, expanded = true }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  useLayoutEffect(() => {
    setIsExpanded(expanded);
  }, []);

  const toggleIsExpanded = () => {
    if (expandable) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className={styles('c-timer', isExpanded && expandable && 'c-timer--expanded')} onClick={toggleIsExpanded}>
      <IconClock size="xsmall" data-testid="ClockIcon" />
      {
        <div
          data-testid="TimerText"
          className={styles('c-timer__text', isExpanded && expandable && 'c-timer__text--visible')}
        >
          <TypographyElements
            text={`${elapsed}`}
            typographyClass="ty-elements-medium"
            className={[styles('c-timer__text__time')]}
          />
          <TypographyElements
            text="di visione senza annunci"
            typographyClass="ty-elements-medium"
            className={[styles('c-timer__text__message')]}
          />
        </div>
      }
    </div>
  );
};

export default Timer;
